import { CLEAR_WISHLIST, WISHLIST_ADD_ITEM, WISHLIST_REMOVE_ITEM, WISHLIST_SET_ITEMS } from "./wishlistActionTypes";

function findItemIndex(items, product) {
    return items.findIndex((item) => item.id === product.id);
}

function addItem(state, product) {
    const itemIndex = findItemIndex(state.items, product);

    let newItems;
    let { lastItemId } = state;

    if (itemIndex === -1) {
        lastItemId += 1;
        newItems = [
            ...state.items,
            {
                ...product,
            },
        ];
    } else {
        newItems = [...state.items];
    }

    return {
        ...state,
        lastItemId,
        items: newItems,
    };
}

function setItems(state, wishlist) {
    const items = wishlist.map((product) => ({
        id: product.productId._id,
        images: product.productId.images,
        name: product.productId.name,
        price: product.productId.price,
    }));

    return {
        ...state,
        items,
    };
}

const initialState = {
    items: [],
    lastItemId: 0,
};

export default function wishlistReducer(state = initialState, action) {
    switch (action.type) {
        case WISHLIST_ADD_ITEM:
            return addItem(state, action.product);

        case WISHLIST_REMOVE_ITEM:
            return {
                ...state,
                items: state.items.filter((x) => x.id !== action.productId),
            };

        case WISHLIST_SET_ITEMS:
            return setItems(state, action.payload);

        case CLEAR_WISHLIST:
            return initialState;

        default:
            return state;
    }
}
